module.exports = __webpack_public_path__ + "media/images/pages/sample_images/sample-editorial-99abb0cc570eb1e5a7c476e57e2e18dd.jpeg";